import { FETCH_SUBMITTED_ORDERS } from '../actions/types';
export default function (state={},action) {
    switch (action.type){
        case FETCH_SUBMITTED_ORDERS:
            return action.payload || false;
        default:
            return state;
    }
}